import { Endpoints } from "../constants/endpoint";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json;charset=utf-8",
};

export const listHighlights = async (transcriptionId) => {
  const res = await fetch(
    `${Endpoints.transcriptionHighlights}by-transcription/${transcriptionId}`,
    { headers }
  );
  if (!res.ok) {
    throw new Error(`listHighlights HTTP ${res.status}`);
  }
  return res.json();
};

export const createHighlight = async (payload) => {
  const res = await fetch(Endpoints.transcriptionHighlights, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`createHighlight HTTP ${res.status}: ${text}`);
  }
  return res.json();
};

export const updateHighlight = async (id, updates) => {
  const res = await fetch(`${Endpoints.transcriptionHighlights}${id}`, {
    method: "PATCH",
    headers,
    body: JSON.stringify(updates),
  });
  if (!res.ok) {
    throw new Error(`updateHighlight HTTP ${res.status}`);
  }
  return res.json();
};

export const deleteHighlight = async (id) => {
  const res = await fetch(`${Endpoints.transcriptionHighlights}${id}`, {
    method: "DELETE",
    headers,
  });
  if (!res.ok) {
    throw new Error(`deleteHighlight HTTP ${res.status}`);
  }
  return res.json();
};
